/**
 * Use this file to import the icons you need from the untitled-ui library if an icon is not already in the list.
 */

import Activity from '@untitled-ui/icons-react/build/cjs/Activity';
import ActivityHeart from '@untitled-ui/icons-react/build/cjs/ActivityHeart';
import Airplay from '@untitled-ui/icons-react/build/cjs/Airplay';
import AlertCircle from '@untitled-ui/icons-react/build/cjs/AlertCircle';
import ArrowCircleRight from '@untitled-ui/icons-react/build/cjs/ArrowCircleRight';
import ArrowCircleUpRight from '@untitled-ui/icons-react/build/cjs/ArrowCircleUpRight';
import ArrowLeft from '@untitled-ui/icons-react/build/cjs/ArrowLeft';
import ArrowRight from '@untitled-ui/icons-react/build/cjs/ArrowRight';
import ArrowUp from '@untitled-ui/icons-react/build/cjs/ArrowUp';
import ArrowUpRight from '@untitled-ui/icons-react/build/cjs/ArrowUpRight';
import Atom01 from '@untitled-ui/icons-react/build/cjs/Atom01';
import Atom02 from '@untitled-ui/icons-react/build/cjs/Atom02';
import Bank from '@untitled-ui/icons-react/build/cjs/Bank';
import BankNote01 from '@untitled-ui/icons-react/build/cjs/BankNote01';
import BarChartSquare02 from '@untitled-ui/icons-react/build/cjs/BarChartSquare02';
import Bookmark from '@untitled-ui/icons-react/build/cjs/Bookmark';
import BookmarkCheck from '@untitled-ui/icons-react/build/cjs/BookmarkCheck';
import BookOpen01 from '@untitled-ui/icons-react/build/cjs/BookOpen01';
import Briefcase01 from '@untitled-ui/icons-react/build/cjs/Briefcase01';
import Briefcase02 from '@untitled-ui/icons-react/build/cjs/Briefcase02';
import Brush01 from '@untitled-ui/icons-react/build/cjs/Brush01';
import Building01 from '@untitled-ui/icons-react/build/cjs/Building01';
import Building06 from '@untitled-ui/icons-react/build/cjs/Building06';
import Building07 from '@untitled-ui/icons-react/build/cjs/Building07';
import Building08 from '@untitled-ui/icons-react/build/cjs/Building08';
import Calculator from '@untitled-ui/icons-react/build/cjs/Calculator';
import Calendar from '@untitled-ui/icons-react/build/cjs/Calendar';
import CalendarDate from '@untitled-ui/icons-react/build/cjs/CalendarDate';
import CalendarPlus01 from '@untitled-ui/icons-react/build/cjs/CalendarPlus01';
import Camera01 from '@untitled-ui/icons-react/build/cjs/Camera01';
import Certificate01 from '@untitled-ui/icons-react/build/cjs/Certificate01';
import Check from '@untitled-ui/icons-react/build/cjs/Check';
import CheckDone01 from '@untitled-ui/icons-react/build/cjs/CheckDone01';
import CheckSquareBroken from '@untitled-ui/icons-react/build/cjs/CheckSquareBroken';
import ChevronDown from '@untitled-ui/icons-react/build/cjs/ChevronDown';
import ChevronLeft from '@untitled-ui/icons-react/build/cjs/ChevronLeft';
import ChevronRight from '@untitled-ui/icons-react/build/cjs/ChevronRight';
import ChevronSelectorVertical from '@untitled-ui/icons-react/build/cjs/ChevronSelectorVertical';
import ChevronUp from '@untitled-ui/icons-react/build/cjs/ChevronUp';
import Circle from '@untitled-ui/icons-react/build/cjs/Circle';
import Clipboard from '@untitled-ui/icons-react/build/cjs/Clipboard';
import Clock from '@untitled-ui/icons-react/build/cjs/Clock';
import CoinsStacked02 from '@untitled-ui/icons-react/build/cjs/CoinsStacked02';
import Colors from '@untitled-ui/icons-react/build/cjs/Colors';
import Compass01 from '@untitled-ui/icons-react/build/cjs/Compass01';
import Copy01 from '@untitled-ui/icons-react/build/cjs/Copy01';
import Copy02 from '@untitled-ui/icons-react/build/cjs/Copy02';
import CpuChip01 from '@untitled-ui/icons-react/build/cjs/CpuChip01';
import CurrencyDollarCircle from '@untitled-ui/icons-react/build/cjs/CurrencyDollarCircle';
import Dataflow01 from '@untitled-ui/icons-react/build/cjs/Dataflow01';
import Dataflow03 from '@untitled-ui/icons-react/build/cjs/Dataflow03';
import Eye from '@untitled-ui/icons-react/build/cjs/Eye';
import EyeOff from '@untitled-ui/icons-react/build/cjs/EyeOff';
import FaceContent from '@untitled-ui/icons-react/build/cjs/FaceContent';
import File01 from '@untitled-ui/icons-react/build/cjs/File01';
import File02 from '@untitled-ui/icons-react/build/cjs/File02';
import File06 from '@untitled-ui/icons-react/build/cjs/File06';
import Film03 from '@untitled-ui/icons-react/build/cjs/Film03';
import FilterLines from '@untitled-ui/icons-react/build/cjs/FilterLines';
import Flag01 from '@untitled-ui/icons-react/build/cjs/Flag01';
import Flag02 from '@untitled-ui/icons-react/build/cjs/Flag02';
import GitPullRequest from '@untitled-ui/icons-react/build/cjs/GitPullRequest';
import Glasses02 from '@untitled-ui/icons-react/build/cjs/Glasses02';
import Globe01 from '@untitled-ui/icons-react/build/cjs/Globe01';
import GraduationHat02 from '@untitled-ui/icons-react/build/cjs/GraduationHat02';
import GridDotsBlank from '@untitled-ui/icons-react/build/cjs/GridDotsBlank';
import GridDotsHorizontalCenter from '@untitled-ui/icons-react/build/cjs/GridDotsHorizontalCenter';
import GridDotsLeft from '@untitled-ui/icons-react/build/cjs/GridDotsLeft';
import GridDotsOuter from '@untitled-ui/icons-react/build/cjs/GridDotsOuter';
import GridDotsTop from '@untitled-ui/icons-react/build/cjs/GridDotsTop';
import GridDotsVerticalCenter from '@untitled-ui/icons-react/build/cjs/GridDotsVerticalCenter';
import Hash01 from '@untitled-ui/icons-react/build/cjs/Hash01';
import Hash02 from '@untitled-ui/icons-react/build/cjs/Hash02';
import Heart from '@untitled-ui/icons-react/build/cjs/Heart';
import HelpCircle from '@untitled-ui/icons-react/build/cjs/HelpCircle';
import HomeSmile from '@untitled-ui/icons-react/build/cjs/HomeSmile';
import Hurricane01 from '@untitled-ui/icons-react/build/cjs/Hurricane01';
import InfoCircle from '@untitled-ui/icons-react/build/cjs/InfoCircle';
import LayerSingle from '@untitled-ui/icons-react/build/cjs/LayerSingle';
import LayersThree01 from '@untitled-ui/icons-react/build/cjs/LayersThree01';
import LayersTwo01 from '@untitled-ui/icons-react/build/cjs/LayersTwo01';
import Lightbulb05 from '@untitled-ui/icons-react/build/cjs/Lightbulb05';
import LinkExternal01 from '@untitled-ui/icons-react/build/cjs/LinkExternal01';
import Lock01 from '@untitled-ui/icons-react/build/cjs/Lock01';
import LockUnlocked01 from '@untitled-ui/icons-react/build/cjs/LockUnlocked01';
import LogIn01 from '@untitled-ui/icons-react/build/cjs/LogIn01';
import LogOut01 from '@untitled-ui/icons-react/build/cjs/LogOut01';
import Luggage02 from '@untitled-ui/icons-react/build/cjs/Luggage02';
import Mail01 from '@untitled-ui/icons-react/build/cjs/Mail01';
import Map01 from '@untitled-ui/icons-react/build/cjs/Map01';
import MarkerPin01 from '@untitled-ui/icons-react/build/cjs/MarkerPin01';
import MarkerPin05 from '@untitled-ui/icons-react/build/cjs/MarkerPin05';
import MessageChatCircle from '@untitled-ui/icons-react/build/cjs/MessageChatCircle';
import Pencil01 from '@untitled-ui/icons-react/build/cjs/Pencil01';
import Phone from '@untitled-ui/icons-react/build/cjs/Phone';
import Phone01 from '@untitled-ui/icons-react/build/cjs/Phone01';
import PiggyBank01 from '@untitled-ui/icons-react/build/cjs/PiggyBank01';
import Plane from '@untitled-ui/icons-react/build/cjs/Plane';
import RefreshCcw05 from '@untitled-ui/icons-react/build/cjs/RefreshCcw05';
import Rocket02 from '@untitled-ui/icons-react/build/cjs/Rocket02';
import Route from '@untitled-ui/icons-react/build/cjs/Route';
import SearchMd from '@untitled-ui/icons-react/build/cjs/SearchMd';
import Send01 from '@untitled-ui/icons-react/build/cjs/Send01';
import Settings01 from '@untitled-ui/icons-react/build/cjs/Settings01';
import Share06 from '@untitled-ui/icons-react/build/cjs/Share06';
import Shield01 from '@untitled-ui/icons-react/build/cjs/Shield01';
import ShieldDollar from '@untitled-ui/icons-react/build/cjs/ShieldDollar';
import Speedometer03 from '@untitled-ui/icons-react/build/cjs/Speedometer03';
import Square from '@untitled-ui/icons-react/build/cjs/Square';
import Target04 from '@untitled-ui/icons-react/build/cjs/Target04';
import Telescope from '@untitled-ui/icons-react/build/cjs/Telescope';
import ThumbsDown from '@untitled-ui/icons-react/build/cjs/ThumbsDown';
import ThumbsUp from '@untitled-ui/icons-react/build/cjs/ThumbsUp';
import Tool02 from '@untitled-ui/icons-react/build/cjs/Tool02';
import Translate01 from '@untitled-ui/icons-react/build/cjs/Translate01';
import Trash01 from '@untitled-ui/icons-react/build/cjs/Trash01';
import Trophy01 from '@untitled-ui/icons-react/build/cjs/Trophy01';
import UploadCloud02 from '@untitled-ui/icons-react/build/cjs/UploadCloud02';
import User01 from '@untitled-ui/icons-react/build/cjs/User01';
import User02 from '@untitled-ui/icons-react/build/cjs/User02';
import User03 from '@untitled-ui/icons-react/build/cjs/User03';
import UserCircle from '@untitled-ui/icons-react/build/cjs/UserCircle';
import Users01 from '@untitled-ui/icons-react/build/cjs/Users01';
import UserUp02 from '@untitled-ui/icons-react/build/cjs/UserUp02';
import VideoRecorder from '@untitled-ui/icons-react/build/cjs/VideoRecorder';
import VolumeMin from '@untitled-ui/icons-react/build/cjs/VolumeMin';
import XClose from '@untitled-ui/icons-react/build/cjs/XClose';
import Youtube from '@untitled-ui/icons-react/build/cjs/Youtube';

export const UNTITLED_UI_ICONS = {
  Activity,
  ActivityHeart,
  Airplay,
  AlertCircle,
  ArrowCircleRight,
  ArrowCircleUpRight,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  ArrowUp,
  Atom01,
  Atom02,
  Bank,
  BankNote01,
  BarChartSquare02,
  Bookmark,
  BookmarkCheck,
  BookOpen01,
  Briefcase01,
  Briefcase02,
  Brush01,
  Building01,
  Building06,
  Building07,
  Building08,
  Calculator,
  Calendar,
  CalendarDate,
  CalendarPlus01,
  Camera01,
  Certificate01,
  Check,
  CheckDone01,
  CheckSquareBroken,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronSelectorVertical,
  ChevronUp,
  Circle,
  Clipboard,
  Clock,
  CoinsStacked02,
  Colors,
  Compass01,
  Copy01,
  Copy02,
  CpuChip01,
  CurrencyDollarCircle,
  Dataflow01,
  Dataflow03,
  Eye,
  EyeOff,
  FaceContent,
  File01,
  File02,
  File06,
  Film03,
  FilterLines,
  Flag01,
  Flag02,
  GitPullRequest,
  Glasses02,
  Globe01,
  GraduationHat02,
  GridDotsBlank,
  GridDotsHorizontalCenter,
  GridDotsLeft,
  GridDotsOuter,
  GridDotsTop,
  GridDotsVerticalCenter,
  Hash01,
  Hash02,
  Heart,
  HelpCircle,
  HomeSmile,
  Hurricane01,
  InfoCircle,
  LayerSingle,
  LayersThree01,
  LayersTwo01,
  Lightbulb05,
  LinkExternal01,
  Lock01,
  LockUnlocked01,
  LogIn01,
  LogOut01,
  Luggage02,
  Mail01,
  Map01,
  MarkerPin01,
  MarkerPin05,
  MessageChatCircle,
  Pencil01,
  Phone,
  Phone01,
  PiggyBank01,
  Plane,
  RefreshCcw05,
  Rocket02,
  Route,
  SearchMd,
  Send01,
  Settings01,
  Share06,
  Shield01,
  ShieldDollar,
  Speedometer03,
  Square,
  Target04,
  Telescope,
  ThumbsDown,
  ThumbsUp,
  Tool02,
  Translate01,
  Trash01,
  Trophy01,
  UploadCloud02,
  User01,
  User02,
  User03,
  UserCircle,
  UserUp02,
  Users01,
  VideoRecorder,
  VolumeMin,
  Youtube,
  XClose,
} as const;
